export const CURRENT_CLIENT_INTERVIEW_SCHEDULE = 'currentClientInterviewSchedule';
